import { useAppSelector } from '../redux/hooks';
import { rolesArray } from '../utils/roles';

const useGroupSettings = () => {
  const groupSettings = useAppSelector((state) => state.groupDetails.data?.settingsUpdate);
  return groupSettings;
};

export default useGroupSettings;
